export function getSessionId(): string | null {
	const match = document.cookie.match(/(?:^|;\s*)sessionid=([^;]+)/);
	return match ? match[1] : null;
}
